import React from 'react';
import Logo from './Logo';
import './Sidebar.css';

const maskPhone = (phone) => {
  const normalized = String(phone || '').replace(/\s+/g, '');
  if (normalized.length < 7) return normalized || '用户';
  return `${normalized.slice(0, 3)}****${normalized.slice(-4)}`;
};

const Sidebar = ({
  onUserClick,
  onContactClick,
  onQuestionTestClick,
  currentChatTitle,
  userInfo,
  historyItems = []
}) => {
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <Logo size={24} />
          <span className="brand-name">玺承SealSeek</span>
        </div>
      </div>

      <div className="sidebar-content">
        {/* 题目测试按钮 */}
        <div className="test-section">
          <button className="test-button" onClick={onQuestionTestClick}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 18V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 15H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>批量测试题目</span>
          </button>
        </div>

        <div className="history-section">
          <div className="section-title">历史记录</div>
          <div className="history-list">
            {historyItems.length > 0 ? (
              historyItems.map((item) => (
                <div
                  key={item.id}
                  className={`history-item ${item.title === currentChatTitle ? 'active' : ''}`}
                >
                  {item.title}
                </div>
              ))
            ) : (
              <div className="history-item">暂无历史记录</div>
            )}
          </div>
        </div>
      </div>

      <div className="sidebar-footer">
        <button type="button" className="sidebar-action contact-button" onClick={onContactClick}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 16.92V19A2 2 0 0 1 20.18 21C11.72 21 3 12.28 3 3.82A2 2 0 0 1 5 2H7.08A2 2 0 0 1 9.05 3.57L9.73 6.11A2 2 0 0 1 9.17 8.18L7.74 9.61A16 16 0 0 0 14.39 16.26L15.82 14.83A2 2 0 0 1 17.89 14.27L20.43 14.95A2 2 0 0 1 22 16.92Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>联系我们</span>
        </button>
        <button type="button" className="sidebar-action user-button" onClick={onUserClick}>
          <div className="user-info">
            <div className="user-avatar">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span className="user-name">{maskPhone(userInfo?.phone)}</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
